import { motion } from "motion/react";
import { Calendar, Clock, ArrowRight } from "lucide-react";

export function ConteudoPage() {
  const posts = [
    {
      category: "Tecnologia",
      title: "Como arquitetura cloud-native transforma operações empresariais",
      excerpt: "Entenda como a migração para cloud pode revolucionar a gestão da sua empresa.",
      date: "12 Mai 2026",
      readTime: "5 min",
      image: "from-blue-500 to-indigo-600"
    },
    {
      category: "IA & Automação",
      title: "Machine Learning aplicado à gestão: cases práticos",
      excerpt: "Descubra como IA está otimizando processos e gerando insights estratégicos.",
      date: "10 Mai 2026",
      readTime: "7 min",
      image: "from-purple-500 to-pink-600"
    },
    {
      category: "Analytics",
      title: "Business Intelligence em tempo real: o futuro da tomada de decisão",
      excerpt: "Como dashboards inteligentes podem acelerar suas decisões estratégicas.",
      date: "08 Mai 2026",
      readTime: "6 min",
      image: "from-green-500 to-emerald-600"
    },
    {
      category: "Cloud",
      title: "Migração para AWS: guia completo para empresas",
      excerpt: "Passo a passo para uma migração segura e bem-sucedida para a nuvem.",
      date: "05 Mai 2026",
      readTime: "8 min",
      image: "from-orange-500 to-red-600"
    },
    {
      category: "Gestão",
      title: "Automação operacional: eliminando gargalos e aumentando eficiência",
      excerpt: "Como workflows inteligentes podem transformar sua operação.",
      date: "03 Mai 2026",
      readTime: "5 min",
      image: "from-cyan-500 to-blue-600"
    },
    {
      category: "Agronegócio",
      title: "Tecnologia no agronegócio: cases de transformação digital",
      excerpt: "Como empresas do agro estão escalando com plataformas inteligentes.",
      date: "01 Mai 2026",
      readTime: "6 min",
      image: "from-yellow-500 to-green-600"
    },
  ];

  return (
    <div className="min-h-screen bg-white pt-20">
      <section className="py-24 px-6 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Conteúdo sobre <span className="bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                tecnologia
              </span> e inovação
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Insights, tendências e conhecimento sobre cloud, IA, automação e gestão empresarial moderna
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post, index) => (
              <motion.article
                key={index}
                className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-100 cursor-pointer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -8 }}
              >
                <div className={`h-48 bg-gradient-to-br ${post.image} flex items-center justify-center`}>
                  <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl"></div>
                </div>

                <div className="p-6">
                  <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                    <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">
                      {post.category}
                    </span>
                    <div className="flex items-center gap-1">
                      <Clock className="w-4 h-4" />
                      {post.readTime}
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-green-600 transition-colors">
                    {post.title}
                  </h3>

                  <p className="text-gray-600 mb-4 line-clamp-2">
                    {post.excerpt}
                  </p>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                      <Calendar className="w-4 h-4" />
                      {post.date}
                    </div>

                    <ArrowRight className="w-5 h-5 text-green-600 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
